import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import useFetch from "../../hooks/useFetch";
import { getRecentReviews } from "../../api/reviews";
import { getImageUrl } from "../../api/utils";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import StarRating from "../StarRating";

const FALLBACK_PRODUCT_IMAGE = "/assets/images/product-placeholder.svg";

const CustomerReviews = ({ shownOnHome = false }) => {
  const { apiData, isLoading } = useFetch(getRecentReviews, 9);
  const reviews = apiData?.reviews || [];

  const renderStars = (rating) =>
    Array(rating)
      .fill()
      .map((_, index) => <i key={index} className="icon-star"></i>);

  return (
    reviews.length > 0 && (
      <section
        className={
          shownOnHome
            ? "flat-spacing-32 sec-bg-banner"
            : "flat-spacing-18 flat-testimonial"
        }
        style={{
          backgroundImage: shownOnHome
            ? "url(/assets/images/reviews-banner.png)"
            : "none",
          borderBottom: shownOnHome ? "none" : "1.5px solid rgb(244, 244, 244)",
          borderTop: shownOnHome ? "none" : "1.5px solid rgb(244, 244, 244)",
        }}
      >
        <div className="container">
          <div className="flat-title wow fadeInUp" data-wow-delay="0s">
            <span className={`title fw-5 ${shownOnHome ? "text-white" : ""}`}>
              Customer Reviews
            </span>
          </div>

          {isLoading ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px 0",
                color: shownOnHome ? "#fff" : "#888",
              }}
            >
              Loading reviews...
            </div>
          ) : reviews.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px 0",
                color: shownOnHome ? "#fff" : "#aaa",
              }}
            >
              No reviews yet.
            </div>
          ) : (
            <div className="wrap-carousel">
              <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={15}
                slidesPerView={1}
                slidesPerGroup={1}
                navigation={{
                  nextEl: ".nav-prev-testimonial",
                  prevEl: ".nav-next-testimonial",
                }}
                pagination={{
                  clickable: true,
                  el: ".sw-pagination-testimonial",
                  dynamicBullets: false,
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                    slidesPerGroup: 2,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    slidesPerGroup: 3,
                  },
                }}
                className="tf-sw-testimonial"
              >
                {reviews.map((review, index) => (
                  <SwiperSlide key={review.id}>
                    <div
                      className="testimonial-item style-column bg_white wow fadeInUp"
                      data-wow-delay={`${index * 0.1}s`}
                      style={{ borderRadius: 0 }}
                    >
                      <div className="rating">{renderStars(review.rating)}</div>
                      <div className="text">"{review.comment}"</div>
                      <div className="author">
                        <div className="name">{review.reviewer_name}</div>
                        <div className="metas">✓ Verified Purchase</div>
                      </div>

                      {review.product && (
                        <div className="product">
                          <div className="image">
                            <a href={`/products/${review.product.slug}`}>
                              <img
                                src={
                                  review.product.image
                                    ? getImageUrl(review.product.image)
                                    : FALLBACK_PRODUCT_IMAGE
                                }
                                alt={review.product.name}
                                onError={(e) => {
                                  e.currentTarget.src = FALLBACK_PRODUCT_IMAGE;
                                }}
                              />
                            </a>
                          </div>
                          <div className="content-wrap">
                            <div className="product-title">
                              <a href={`/products/${review.product.slug}`}>
                                {review.product.name}
                              </a>
                            </div>
                            <div className="price">
                              Starting from ₹
                              {Number(review.product.price).toLocaleString(
                                "en-IN",
                              )}
                              {review.product.compare_price >
                                review.product.price && (
                                <span
                                  className="compare-at-price"
                                  style={{
                                    marginLeft: 8,
                                    fontSize: 12,
                                    color: "#aaa",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  ₹
                                  {Number(
                                    review.product.compare_price,
                                  ).toLocaleString("en-IN")}
                                </span>
                              )}
                            </div>
                          </div>
                          <a href={`/products/${review.product.slug}`}>
                            <i className="icon-arrow1-top-left"></i>
                          </a>
                        </div>
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div
                className={`nav-sw ${shownOnHome ? "style-white" : ""} nav-next-slider nav-next-testimonial lg`}
              >
                <span className="icon icon-arrow-left"></span>
              </div>
              <div
                className={`nav-sw ${shownOnHome ? "style-white" : ""} nav-prev-slider nav-prev-testimonial lg`}
              >
                <span className="icon icon-arrow-right"></span>
              </div>
              <div
                className={`sw-dots ${shownOnHome ? "dots-white" : ""} style-2 sw-pagination-testimonial justify-content-center`}
              ></div>
            </div>
          )}
        </div>
      </section>
    )
  );
};

export default CustomerReviews;
